import React from "react";
import { Modal, Row, Col } from "react-bootstrap";

const ProductViewModal = ({ show, handleClose, product }) => {
  const images =
  product?.images?.map((img) => img.image) || [];

  return (
    <Modal show={show} onHide={handleClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Product Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-4">
          <div className="d-flex flex-wrap gap-2 justify-content-center">
            {images.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`Product-${index}`}
                style={{
                  width: "140px",
                  height: "140px",
                  objectFit: "cover",
                  borderRadius: "10px",
                  border: "1px solid #ddd",
                  padding: "3px",
                }}
              />
            ))}
          </div>
        </div>

        <div className="table-responsive">
          <table className="table table-bordered">
            <tbody>
              <tr>
                <th>Bar Code</th>
                <td>{product?.item_code || "N/A"}</td>

                <th>Item Name</th>
                <td>{product?.name || "N/A"}</td>
              </tr>

              <tr>
                <th>Design ID</th>
                <td>{product?.design_id || "N/A"}</td>

                <th>Category</th>
                <td>{product?.p_category_id?.label || "N/A"}</td>
              </tr>

              <tr>
                <th>Sub Category</th>
                <td>{product?.p_sub_category_id?.label || "N/A"}</td>

                <th>Brand</th>
                <td>{product?.brand_id?.label || "N/A"}</td>
              </tr>

              <tr>
                <th>Colour</th>
                <td>{product?.Colour || "N/A"}</td>

                <th>Size</th>
                <td>{product?.Size || "N/A"}</td>
              </tr>

              <tr>
                <th>Polish</th>
                <td>{product?.Plating || "N/A"}</td>

                <th>Unit</th>
                <td>{product?.unit || "N/A"}</td>
              </tr>

              <tr>
                <th>HSN</th>
                <td>{product?.HSN || "N/A"}</td>

                <th>MRP</th>
                <td>₹ {product?.mrp || 0}</td>
              </tr>

              <tr>
                <th>Sale Price</th>
                <td>₹ {product?.price || 0}</td>

                <th>Base Metal</th>
                <td>{product?.base_metal || "N/A"}</td>
              </tr>

              <tr>
                <th>Description</th>
                <td colSpan={3}>{product?.description || "N/A"}</td>
              </tr>

              <tr>
                <th>Product Description</th>
                <td colSpan={3}>{product?.product_description || "N/A"}</td>
              </tr>

              <tr>
                <th>Stone</th>
                <td>{product?.stone || "N/A"}</td>

                <th>Necklace Style</th>
                <td>{product?.neckalace_style || "N/A"}</td>
              </tr>

              <tr>
                <th>Earring Style</th>
                <td>{product?.earring_style || "N/A"}</td>

                <th>Earring Closer Type</th>
                <td>{product?.earring_closer_type || "N/A"}</td>
              </tr>

              <tr>
                <th>Product Weight</th>
                <td>{product?.product_weight || "N/A"}</td>

                <th>Product Length</th>
                <td>{product?.product_length || "N/A"}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ProductViewModal;
